// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_1og-ZSQVGsGJqJVIMJLcq0","tab":"_3205aBayGaV-Z2-zb9Vuwo","active":"_2ykWaQsjE-4uaagkp3yJ6I","disabled":"_3wSzKs0HOo02aR3PUzVT4J"};